
const sanitize = ({
    id,
    name,
    date,
    description,
    facilitatorId,
    locationId,
    hourId,
    durationId,
    minCapacity,
    maxCapacity,
    credits,
    dimensions,
    gradeLevels,
    requirements,
    occurrences,
}) => ({
    id,
    name,
    date,
    description,
    facilitatorId,
    locationId,
    hourId,
    durationId,
    minCapacity,
    maxCapacity,
    credits,
    dimensions,
    gradeLevels,
    requirements,
    occurrences,
})

export default sanitize